import type { CheckoutDialogTracking, CheckoutPaymentFailureTracking } from '../types';

const ERROR_STEP_WRAPPER_CLASS_NAME = 'w-full flex flex-col flex-1 gap-8 px-6 pt-6 pb-10';

type BuildErrorStepWrapperPropsParams = {
  paymentFailureTracking?: CheckoutPaymentFailureTracking;
  errorTrackContainer?: string;
  dialogTracking?: CheckoutDialogTracking;
};

function buildErrorStepWrapperProps({ paymentFailureTracking, errorTrackContainer, dialogTracking }: BuildErrorStepWrapperPropsParams) {
  if (paymentFailureTracking) {
    const { method, provider, type, count, amount } = paymentFailureTracking;

    return {
      className: ERROR_STEP_WRAPPER_CLASS_NAME,
      'data-testid': 'checkout-error-step',
      'data-track-container': 'Failure Confirmation',
      'data-track-method': method,
      'data-track-provider': provider,
      ...(type ? { 'data-track-type': type } : {}),
      'data-track-count': count,
      'data-track-amount': amount,
    };
  }

  if (errorTrackContainer) {
    return {
      className: ERROR_STEP_WRAPPER_CLASS_NAME,
      'data-testid': 'checkout-error-step',
      'data-track-container': errorTrackContainer,
    };
  }

  if (dialogTracking) {
    return {
      className: ERROR_STEP_WRAPPER_CLASS_NAME,
      'data-testid': 'checkout-error-step',
      'data-track-container': 'Amount',
    };
  }

  return {
    className: ERROR_STEP_WRAPPER_CLASS_NAME,
    'data-testid': 'checkout-error-step',
  };
}

export { buildErrorStepWrapperProps, ERROR_STEP_WRAPPER_CLASS_NAME, type BuildErrorStepWrapperPropsParams };
